import "./CompanyFounderCard.css";
import { escapeWealthHtml as esc, formatWealthValue as worth, wealthPersonImage, type WealthResponse } from "./WealthTypes";

export function renderCompanyFounders(container: HTMLElement, data: WealthResponse): void {
  const founders = Array.isArray(data.founder_names) ? data.founder_names : [];
  const people = Array.isArray(data.people) ? data.people : [];
  container.innerHTML = `
    <section class="company-founder-card">
      <div class="wealth-kicker">COMPANY FOUNDERS</div>
      <h1>${esc(data.company_name || "Company")}</h1>
      <p class="company-founder-overview">${esc(data.overview || "")}</p>
      <div class="company-founder-people">
        ${founders.map((name) => {
          const person = people.find((candidate) => candidate.name === name);
          return `
            <article class="company-founder-person">
              <div class="company-founder-avatar">${person ? wealthPersonImage(person) : `<div class="wealth-person-placeholder">${esc(name.charAt(0))}</div>`}</div>
              <div>
                <strong>${esc(name)}</strong>
                ${person?.rank ? `<span>Forbes world rank #${person.rank}</span>` : ""}
                ${person?.net_worth_usd ? `<span>${esc(worth(person.net_worth_usd))} current cached net worth</span>` : ""}
              </div>
            </article>
          `;
        }).join("")}
      </div>
      <div class="wealth-source">
        <span>AyeSearch curated company profile</span>
        ${data.source?.url ? `<a href="${esc(data.source.url)}" target="_blank" rel="noopener noreferrer">${esc(data.source.name || "Official source")}</a>` : ""}
      </div>
    </section>
  `;
}
